import { render, staticRenderFns } from "./VideoMetaData.vue?vue&type=template&id=60c89abe&scoped=true&"
import script from "./VideoMetaData.vue?vue&type=script&lang=js&"
export * from "./VideoMetaData.vue?vue&type=script&lang=js&"
import style0 from "./VideoMetaData.vue?vue&type=style&index=0&id=60c89abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c89abe",
  null
  
)

export default component.exports